module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/consigner.d065bc68.svg";